import { connect } from 'react-redux'
import AssetDetailView  from './AssetDetailView.jsx'
import { selectAsset, invalidateAssetSelection, invalidateCollectionsSelection } from 'src/legacy/redux/actions/selection.jsx';
import { 
  invalidateAssetSearchResult,
  invalidateCollectionsSearchResult, invalidateStreamsSearchResult, 
  invalidateContactsSearchResult, invalidateTags, invalidateContactListsSearchResult
} from 'src/legacy/redux/actions/search.jsx';

import {recordSearchClick} from 'src/legacy/redux/actions/hub.jsx'
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import { trackAdoptionMetricsForAddToCollectionClickedEvent } from 'src/legacy/redux/actions/adoption.jsx';

const mapStateToProps = (state, ownProps) => {
  return {
    details: state.legacyRootReducer.search.assetDetails.item,
    loading: state.legacyRootReducer.search.assetDetails.loading,
    customFields: state.legacyRootReducer.settings.customFields.items || [],
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    selectAsset: (asset) => {
      dispatch(invalidateAssetSelection());
      dispatch(selectAsset(asset));
    },

    // invalidateLink:() => {
    //   return dispatch(invalidateLink());
    // },

    invalidateCollectionsSelection: ()=>{
      return dispatch(invalidateCollectionsSelection());
    },
    invalidateAssetSearchResult: () => {
      return dispatch(invalidateAssetSearchResult());
    },
    invalidateCollectionsSearchResult: () => {
      return dispatch(invalidateCollectionsSearchResult());
    },
    invalidateStreamsSearchResult: () => {
      return dispatch(invalidateStreamsSearchResult());
    },
    invalidateContactsSearchResult: () => {
      return dispatch(invalidateContactsSearchResult());
    },
    invalidateTags: () => {
      return dispatch(invalidateTags())
    },
    invalidateContactListsSearchResult: () => {
      return dispatch(invalidateContactListsSearchResult());
    },
    recordSearchClick:(id, type) => {
      return dispatch(recordSearchClick(id,type));
    },
    trackAdoptionMetricsForAddToCollectionClickedEvent: (fileType) => {
      return dispatch(trackAdoptionMetricsForAddToCollectionClickedEvent(fileType));
    }
  }
}

const AssetDetailViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetDetailView)

export default withUseHooks(AssetDetailViewContainer);